import classnames from 'classnames';
import { type FC, useEffect } from 'react';
import { type RouteComponentProps, useLocation } from 'wouter';

import AccountPageNavigation from 'components/AccountPageNavigation';
import AccountLayout from 'components/Layouts/Account';
import useLayout, { LayoutType } from 'utils/layout';

import RealityCheckSection from './sections/RealityCheckSection';
import SelfExclusionsSection from './sections/SelfExclusionsSection';
import SelfRegulationSection from './sections/SelfRegulationSection';

import styles from './ResponsibleGamingPage.module.scss';

const sections = [
  {
    title: 'self_regulation',
    link: '~/account/responsible-gaming/self-regulation',
  },
  {
    title: 'reality_check',
    link: '~/account/responsible-gaming/reality-check',
  },
  {
    title: 'self_exclusion',
    link: '~/account/responsible-gaming/self-exclusions',
  },
];

export enum ResponsibleGamingSection {
  'self-regulation' = 'self-regulation',
  'reality-check' = 'reality-check',
  'self-exclusions' = 'self-exclusions',
}

type ResponsibleGamingPageProps = {
  section: ResponsibleGamingSection;
};

const ResponsibleGamingPage: FC<
  RouteComponentProps<ResponsibleGamingPageProps>
> = ({ params }) => {
  const [, setLocation] = useLocation();
  const layout = useLayout();

  useEffect(() => {
    if (!ResponsibleGamingSection[params.section]) {
      setLocation(sections[0].link, { replace: true });
    }
  }, [params.section, setLocation]);

  return (
    <AccountLayout
      icon="security-time.bold"
      className={classnames({
        [styles['responsible-gaming-layout']]: layout === LayoutType.mobile,
      })}
      title="responsible_gaming"
    >
      <div className={styles['responsible-gaming-content']}>
        <AccountPageNavigation
          pages={sections}
          className={classnames({
            [styles.navigation]: layout === LayoutType.mobile,
          })}
        />
        <div
          className={classnames(styles['responsible-gaming-sections'], [
            styles[layout],
          ])}
        >
          {params.section === ResponsibleGamingSection['self-regulation'] && (
            <SelfRegulationSection />
          )}
          {params.section === ResponsibleGamingSection['self-exclusions'] && (
            <SelfExclusionsSection />
          )}
          {params.section === ResponsibleGamingSection['reality-check'] && (
            <RealityCheckSection />
          )}
        </div>
      </div>
    </AccountLayout>
  );
};

export default ResponsibleGamingPage;
